import core_sources from "./source/core.sources";
import art_uploader from "./artuploader/artuploader.json";

const sources = {
  core: core_sources,
  artuploader: art_uploader,
};

export default sources;
